import Vue from 'vue'
import Vuex from 'vuex'
import store from 'store'

import Cookies from 'js-cookie'

Vue.use(Vuex)

const SESSION_SETTINGS = new Set(['isMenuCollapsed'])

const STORED_SETTINGS = storedSettings => {
  const settings = {}
  Object.keys(storedSettings).forEach(key => {
    const item = store.get(`app.settings.${key}`)
    settings[key] = !SESSION_SETTINGS.has(key) && typeof item !== 'undefined'
      ? item
      : storedSettings[key]
  })
  return settings
}

export default {
  namespaced: true,
  state: {
    ...STORED_SETTINGS({
      authProvider: 'jwt',
      logo: 'PowerBiz',
      locale: Cookies.get('app.settings.locale') || 'id-ID',
      isSidebarOpen: false,
      isSupportChatOpen: false,
      isMobileView: false,
      isMobileMenuOpen: false,
      isMenuCollapsed: false,
      menuLayoutType: 'left',
      routerAnimation: 'slide-fadein-up',
      menuColor: 'white',
      theme: 'default',
      authPagesColor: 'white',
      primaryColor: '#4b7cf3',
      leftMenuWidth: 260,
      isMenuUnfixed: false,
      isMenuShadow: false,
      isTopbarFixed: true,
      isGrayTopbar: false,
      isContentMaxWidth: false,
      isAppMaxWidth: false,
      isGrayBackground: false,
      isCardShadow: true,
      isSquaredBorders: false,
      isBorderless: false,
      selectedMenu: Cookies.get('app.settings.selectedMenu') ? JSON.parse(Cookies.get('app.settings.selectedMenu')) : [],
      openedMenu: Cookies.get('app.settings.openedMenu') ? JSON.parse(Cookies.get('app.settings.openedMenu')) : [],
    }),
  },
  mutations: {
    CHANGE_SETTING(state, payload) {
      if (payload.value && !SESSION_SETTINGS.has(payload.setting)) {
        Cookies.set(`app.settings.${payload.setting}`, typeof payload.value === 'object' ? JSON.stringify(payload.value) : payload.value)
        store.set(`app.settings.${payload.setting}`, payload.value)
      }

      state[payload.setting] = payload.value
    },
    SETUP_URL_SETTINGS(state, payload) {
      let queryParams = payload
      let keys = false
      if (payload.redirect) {
        const str = payload.redirect
        const subs = str.substring(str.indexOf('?') + 1)
        if (str.indexOf('?') >= 0) {
          queryParams = JSON.parse('{"' + decodeURI(subs).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
        }
      }
      delete queryParams.redirect
      keys = Object.keys(queryParams)
      if (keys.length) {
        keys.forEach(key => {
          let value
          switch (queryParams[key]) {
            case 'false':
              value = false
              break
            case 'true':
              value = true
              break
            default:
              value = queryParams[key]
              break
          }
          if (key in state) { state[key] = value }
        })
      }
    },
    SET_PRIMARY_COLOR(state, payload) {
      const { color } = payload
      const addStyles = () => {
        const styleElement = document.querySelector('#primaryColor')
        if (styleElement) {
          styleElement.remove()
        }
        const body = document.querySelector('body')
        const styleEl = document.createElement('style')
        const css = document.createTextNode(``)
        styleEl.setAttribute('id', 'primaryColor')
        styleEl.appendChild(css)
        body.appendChild(styleEl)
      }
      addStyles()
      state.primaryColor = color
      store.set('app.settings.primaryColor', color)
    },
    SET_THEME(state, payload) {
      const { theme } = payload
      const nextTheme = theme === 'dark' ? 'dark' : 'default'
      document.querySelector('html').setAttribute('data-kit-theme', nextTheme)
      state.theme = nextTheme
      store.set('app.settings.theme', nextTheme)
    },
  },
  actions: {},
  getters: {
    state: state => state,
  },
}
